import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useMemo, useState } from 'react';

const QuickSearchToolbar = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'end',
        p: 0.5,
        pb: 0,
      }}
    >
      <GridToolbarQuickFilter />
    </Box>
  );
};

const DataTable = ({
  height = '100%',
  width = '100%',
  rows,
  columns,
  loading,
  rowClick = () => {},
  components,
  componentsProps,
}) => {
  const [pageSize, setPageSize] = useState(10);
  const rowsWithIds = useMemo(
    () =>
      rows.map((row, index) => {
        // DataGrid must have a unique row id. Problems we've seen:
        // 1) Backend rows can carry a generic `id` (often the same for every row); v5 still keys
        //    off that field in ways that duplicate one row across the grid unless it is removed.
        // 2) Any chosen key (recno, itemNo, …) can still collide across UNION/query shapes.
        // So: drop `id` from the row model, prefer DB keys, and suffix with index for uniqueness.
        const rest = { ...row };
        delete rest.id;

        console.log();
        const candidates = [
          rest.recno,
          rest.ownerRecno,
          rest.itemNo,
          rest.assetId,
          rest.contactId,
          rest.partyId,
        ];
        const picked = candidates.find((v) => v != null && v !== '');
        const base = picked !== undefined ? String(picked) : 'row';
        const __rowId = `${base}-${index}`;
        return {
          ...rest,
          __rowId,
        };
      }),
    [rows]
  );

  return (
    <Box style={{ height, width }} sx={{ bgcolor: 'white' }}>
      {/* https://github.com/mui/mui-x/issues/4076 */}
      <DataGrid
        sx={{
          pt: '20px',
          px: '40px',
          pb: '40px',
          '.MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel': {
            my: '1rem',
          },
        }}
        rows={rowsWithIds}
        columns={columns}
        disableMultipleSelection={true}
        onRowClick={(item) => rowClick(item)}
        // When no toolbar component is provided, default to QuickSearchToolbar for the toolbar
        components={{
          Toolbar: components?.toolbar || QuickSearchToolbar,
          ...components,
        }}
        // Passing props to components in this manner
        componentsProps={{
          toolbar: componentsProps?.toolbar,
          ...componentsProps,
        }}
        getRowId={(row) => row.__rowId}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[10, 25, 50, 100]}
        loading={loading}
      />
    </Box>
  );
};
export default DataTable;
